<template>
    <slider class="hp-slider" autoplay loop v-if="data.length">
        <slide v-for="(item, index) in data" :key="index">
            <div class="hp-slide" :style="`background-image: url(${item.image});`">
                <div class="container">
                    <div class="hp-slide__content">
                        <z-caption
                            class="hp-slide__title white-text"
                            tag="h1"
                        >
                            <span v-html="item.name"></span>
                            <span v-if="item.period" class="secondary-text" v-html="item.period"></span>
                        </z-caption>
                        <div class="hp-slide__wrapper">
                            <z-button
                                tag="a"
                                :href="item.link"
                                kind="secondary"
                                theme="white"
                            >
                                <span v-html="text.more"></span>
                                <template v-slot:right>
                                    <z-icon name="arrow_long" width="40" dir="right" height="24"></z-icon>
                                </template>
                            </z-button>
                            <z-filelist size="s" v-if="item.file.link">
                                <z-filelist-item
                                    icon="download"
                                    :info="`(${item.file.type}), ${item.file.size}`"
                                >
                                    <z-link :href="item.file.link">
                                        <span v-html="item.file.name"></span>
                                    </z-link>
                                </z-filelist-item>
                            </z-filelist>
                        </div>
                    </div>
                </div>
            </div>
        </slide>
    </slider>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'HpSlider',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                more: localize({
                    ru: 'Подробнее',
                    en: 'More'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.hp-slider {
    .slider__controls {
        position: absolute;
        bottom: $token-spacers-l;
        left: 0;
        width: 100%;
        z-index: 2;
        padding-right: $token-grids-desktop-offset;
        padding-left: $token-grids-desktop-offset;

        @include breakpoint(laptop) {
            padding-right: $token-grids-laptop-offset;
            padding-left: $token-grids-laptop-offset;
        }

        @include breakpoint(tablet) {
            padding-right: $token-grids-tablet-offset;
            padding-left: $token-grids-tablet-offset;
        }

        @include breakpoint(v-tablet) {
            padding-right: $token-grids-v-tablet-offset;
            padding-left: $token-grids-v-tablet-offset;
        }

        @include breakpoint(mobile) {
            padding-right: $token-grids-mobile-offset;
            padding-left: $token-grids-mobile-offset;
            bottom: $token-spacers-s;
        }

        .z-icon path {
            fill: $token-colors-white;
        }

        .swiper-pagination-bullet {
            background: $token-colors-white;
            opacity: 1;
        }
    }

    .swiper-slide {
        height: auto !important;
    }
}

.hp-slide {
    position: relative;
    background-color: $token-colors-black-5;
    @include padding-level(top, 2XL);
    padding-bottom: 150px;
    background-size: cover;
    background-position: 70% 50%;
    background-repeat: no-repeat;
    height: 100%;

    @include breakpoint (mobile) {
        padding-bottom: 80px;
    }

    &__img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }

    &__content {
        position: relative;
    }

    &__title {
        max-width: 80%;
        color: $token-colors-white;
        @include breakpoint (mobile) {
            font-size: 28px !important;
        }
    }

    &__wrapper {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 72px!important;
        line-height: 1.1!important;
    }

    .z-button {
        align-self: flex-end;
    }
    .z-filelist {
        display: inline-flex;
        width: auto;
        background-color: #FFFFFF;
        padding: $token-spacers-xs;
        min-width: 280px;

        @include breakpoint (v-tablet) {
            padding: $token-spacers-2-xs;
        }

        @include breakpoint (mobile) {
            position: relative;
            margin-top: $token-spacers-xs;
            display: flex;
            padding: 14px;
            justify-content: center;
        }
    }

    .z-filelist-item {
        &__slot {
            font-weight: 500 !important;
        }
    }

    @include breakpoint (mobile) {
        .z-filelist-item {
            &__content {
                margin-left: 8px;
                display: flex;
                align-items: center;
            }

            &__slot {
                font-size: 16px;
            }

            &__info-size {
                font-size: 14px;
            }

            &__info {
                margin-top: 0;
                margin-left: 6px;
            }

            &__icon {
                width: 24px !important;
                height: 24px !important;

                .z-icon {
                    width: 100% !important;
                    height: 100% !important;
                }
            }
        }
    }
}

@media (max-width: 840px) {
    .hp-slide {
        .z-button {
            margin-bottom: 20px;
        }
    }
}
</style>
